import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Data from "../assets/Data";

const Work = () => {
  return (
    <div id="work">
      <h2>WORK</h2>
      <section>
        <article>
          <Carousel
            showArrows={false}
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            interval={2000}
            infiniteLoop={true}
            autoPlay={true}
          >
            {Data.map((i) => (
              <div
                key={i.title}
                className="workItem"
                style={{ padding: "10px" }}
              >
                <img src={i.imgSrc} alt={i.title} />
                <aside>
                  <h3>{i.title}</h3>
                  <div
                    style={{
                      overflow: "auto",
                      padding: "40px",
                      height: "200px",
                    }}
                  >
                    <style>
                      {`
      /* Style the scrollbar track */
      ::-webkit-scrollbar {
        width: 12px; /* Adjust the width as needed */
      }

      /* Style the scrollbar thumb (the draggable part) */
      ::-webkit-scrollbar-thumb {
        background-color: red; /* Change the color to red */
        border-radius: 6px; /* Round the corners */
      }

      /* Optionally, style the scrollbar track on hover */
      ::-webkit-scrollbar-track:hover {
        background-color: rgba(255, 0, 0, 0.2); /* Change the color on hover */
      }
    `}
                    </style>
                    <p>{i.description}</p>
                  </div>

                  <a target="_blank" rel="noopener noreferrer" href={i.url}>
                    View Demo
                  </a>
                </aside>
              </div>
            ))}
          </Carousel>
        </article>
      </section>
    </div>
  );
};

export default Work;
